var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3DViewer = function Svg3DViewer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39.465,
    x: 0.5,
    fill: "#46D581",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39.465,
    x: 0.5,
    fill: "url(#3d-viewer_svg__a)",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    d: "m12.874 26.836 1.08-3.272h5.248l1.08 3.272h3.295l-5.015-14.351H14.6L9.58 26.836zm1.86-5.64 1.79-5.432h.114l1.79 5.431zM25.27 26.836h3.026v-6.09c0-1.324.98-2.235 2.316-2.235.419 0 .994.07 1.278.162v-2.65a4.6 4.6 0 0 0-.952-.104c-1.221 0-2.223.7-2.62 2.032h-.114v-1.878H25.27z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3d-viewer_svg__a",
    x1: 0.5,
    x2: 36.162,
    y1: 7.202,
    y2: 39.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6EE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1FF2C",
    stopOpacity: 0.22
  })))));
};
export default Svg3DViewer;